import { Spinner } from "@swivl-mono/ui";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { AnonymousAccessNavBar } from "../../Components/AnonymousAccessNavBar/AnonymousAccessNavBar";
import ErrorView from "../../Components/ErrorView/ErrorView";
import { useAccessOrgRedirect } from "../../Hooks/useAccessOrgRedirect";
import { setTicketAccessOverride, useTicketingStore } from "../../Models/Ticketing/Ticketing.Store";
import { AccessRelatedTicketsList } from "../Ticketing/components/AccessRelatedTicketsList";
import { TicketWorkspaceColumns } from "../Ticketing/components/TicketWorkspaceColumns";

// The emailed ticket link — same layout/components as /inbox, locked fields.
export default function TicketAccessView() {
  const { token } = useParams<{ token: string }>();
  const ticket = useTicketingStore((s) => s.ticket);
  const error = useTicketingStore((s) => s.detailError);
  const load = useTicketingStore((s) => s.loadByAccessToken);

  // Tracks whether THIS token's load finished, ignoring stale `ticket` values.
  const [loadedToken, setLoadedToken] = useState<string | null>(null);
  const hasLoaded = loadedToken === token;

  useEffect(() => {
    setLoadedToken(null);
    if (token) void load(token).finally(() => setLoadedToken(token));
    return () => setTicketAccessOverride(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const { showSpinner } = useAccessOrgRedirect({
    hasLoaded,
    resourceOrgId: ticket?.orgId,
    realPath: ticket ? `/inbox/ticket/${ticket.number}` : null,
    resourceLabel: "This ticket"
  });

  return (
    <div className="flex h-screen flex-col">
      <AnonymousAccessNavBar />
      {error ? (
        <div className="flex flex-1 items-center justify-center bg-grey-50">
          <ErrorView />
        </div>
      ) : showSpinner ? (
        <div className="flex flex-1 items-center justify-center bg-grey-50">
          <Spinner />
        </div>
      ) : (
        <div className="grid min-h-0 flex-1 grid-cols-1 gap-3 bg-grey-50 p-3 lg:grid-cols-[20%_1fr]">
          <div className="hidden min-h-0 overflow-hidden lg:block">
            {token && ticket && <AccessRelatedTicketsList token={token} currentTicketId={ticket.id} />}
          </div>
          <TicketWorkspaceColumns favorDetail />
        </div>
      )}
    </div>
  );
}
